import React from "react";
// Removed FBProfile import as it's no longer needed for hardcoded data

interface NewMembersSectionProps {
  className?: string;
  // Removed profiles: FBProfile[];
}

const hardcodedMembers = [
  {
    name: "bllackromina",
    image:
      "https://cirfpiznfmoenfrvuyfv.supabase.co/storage/v1/object/public/profile-assets/static/lander/bllackromina.jpg",
  },
  {
    name: "carrylucy",
    image:
      "https://cirfpiznfmoenfrvuyfv.supabase.co/storage/v1/object/public/profile-assets/static/lander/carrylucy.jpg",
  },
  {
    name: "alisondean",
    image:
      "https://cirfpiznfmoenfrvuyfv.supabase.co/storage/v1/object/public/profile-assets/static/lander/alisondean.jpg",
  },
  {
    name: "supercute",
    image:
      "https://cirfpiznfmoenfrvuyfv.supabase.co/storage/v1/object/public/profile-assets/static/lander/supercute.jpg",
  },
  {
    name: "Katielove65",
    image:
      "https://cirfpiznfmoenfrvuyfv.supabase.co/storage/v1/object/public/profile-assets/static/lander/katielove65.jpg",
  },
  {
    name: "Monique",
    image:
      "https://cirfpiznfmoenfrvuyfv.supabase.co/storage/v1/object/public/profile-assets/static/lander/monique.jpg",
  },
  {
    name: "Gabriella",
    image:
      "https://cirfpiznfmoenfrvuyfv.supabase.co/storage/v1/object/public/profile-assets/static/lander/gabriella.jpg",
  },
  {
    name: "InHisHands",
    image:
      "https://cirfpiznfmoenfrvuyfv.supabase.co/storage/v1/object/public/profile-assets/static/lander/inhishands.jpg",
  },
];

export default function NewMembersSection({
  className,
}: // Removed profiles,
NewMembersSectionProps) {
  return (
    <section className={`py-16 px-4 text-center text-white ${className}`}>
      <h2 className="text-3xl md:text-4xl font-bold mb-12 text-white">
        {" "}
        {/* Changed text-primary to text-white */}
        Chat With New People Today!
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-2 md:gap-x-4 gap-y-4 w-[50dvw] mx-auto">
        {" "}
        {/* Adjusted horizontal gap */}
        {hardcodedMembers.map(
          (
            member // Use hardcodedMembers
          ) => (
            <div
              key={member.name} // Use name as key for hardcoded data
              className="relative flex flex-col items-center rounded-lg overflow-hidden bg-[#c56c7f]/60 shadow-lg w-full max-w-[180px] mx-auto
                         transform transition-all duration-300 hover:scale-[115%] hover:border-black hover:border-2 border-transparent" // Added hover effects and transparent border
            >
              <img
                src={member.image} // Use hardcoded image
                alt={member.name} // Use hardcoded name
                className="w-full h-auto object-cover rounded-t-lg aspect-square" // Image fills width, rounded top corners, and square aspect ratio
              />
              {/* Gradient Overlay */}
              <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/70 to-transparent"></div>
              {/* Text Overlay */}
              <div className="absolute inset-x-0 bottom-0 p-2 text-center w-full z-10">
                <p className="text-lg font-bold text-white mb-1">
                  {member.name}
                </p>
                <p className="text-xs text-gray-300">Recently Active</p>
              </div>
            </div>
          )
        )}
      </div>
    </section>
  );
}
